module.exports = __webpack_public_path__ + "media/bootstrap-icons/person-dash-13c5daf4.svg";